import React from 'react';
import StoreList from './StoresList'

const index = () => {
    return (
        <StoreList />
    )
}

export default index